import { render, staticRenderFns } from "./GameHeaderN.vue?vue&type=template&id=61427e9b&"
import script from "./GameHeaderN.vue?vue&type=script&lang=js&"
export * from "./GameHeaderN.vue?vue&type=script&lang=js&"
import style0 from "./GameHeaderN.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports